import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Loading = () => (
  <div data-testid="loading" className="grid min-h-[40vh] place-items-center text-gray-500">
    <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
  </div>
);

export const RequireAuth = ({ children, role, needShop }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={`/connexion?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  if (needShop && !user.shop) return <Navigate to="/devenir-vendeur" replace />;
  return children;
};
